"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5600],{

/***/ 95600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ SideBySideWithBackgroundTextAndAssetComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-text-and-asset/side-by-side-text-and-asset-component.js
var side_by_side_text_and_asset_component = __webpack_require__(8150);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-with-background-text-and-asset/side-by-side-with-background-text-and-asset-component.scss.js

var StyledSideBySideWithBackgroundTextAndAssetComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ejprjsb0"
})("display:flex;.side-by-side-asset-wrapper{flex-grow:1;.side-by-side-text-and-asset-component{height:100%;}}");

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-with-background-text-and-asset/side-by-side-with-background-text-and-asset-component.js






function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var SideBySideWithBackgroundTextAndAssetComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SideBySideWithBackgroundTextAndAssetComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SideBySideWithBackgroundTextAndAssetComponent);
    function SideBySideWithBackgroundTextAndAssetComponent() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, SideBySideWithBackgroundTextAndAssetComponent);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getStyle", function() {
            var minHeight = _this.props.minHeight;
            if (!minHeight) return {};
            return {
                minHeight: minHeight
            };
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(SideBySideWithBackgroundTextAndAssetComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSideBySideWithBackgroundTextAndAssetComponent, {
                    className: "side-by-side-with-background-text-and-asset-component",
                    style: this.getStyle(),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "side-by-side-asset-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(side_by_side_text_and_asset_component["default"], _object_spread({}, this.props))
                    })
                });
            }
        }
    ]);
    return SideBySideWithBackgroundTextAndAssetComponent;
}(react.PureComponent);

SideBySideWithBackgroundTextAndAssetComponent.defaultProps = _object_spread_props(_object_spread({}, side_by_side_text_and_asset_component["default"].defaultProps), {
    background: {
        width: "75%",
        color: segments_service/* WORKOS_IRIS_THEME_ID */.M1
    },
    asset: _object_spread_props(_object_spread({}, side_by_side_text_and_asset_component["default"].defaultProps.asset), {
        position: "center",
        image: _object_spread_props(_object_spread({}, side_by_side_text_and_asset_component["default"].defaultProps.asset.image), {
            src: "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/remote_mondaycom_static/img/segment-layout-default-images/text-and-asset/designers-sit-together.png"
        })
    }),
    paddingTop: "0px",
    paddingBottom: "0px",
    minHeight: "650px"
});


/***/ })

}]);